import React, {Component} from 'react';
import {Row, Col} from "react-bootstrap";
import ReactNotify from 'react-notify';
import KalendarzDoDatyForm from "./components/KalendarzDoDatyForm";
import KalendarzDoDatyTable from "./components/KalendarzDoDatyTable";
import KalendarzDoDatyService from "./KalendarzDoDatyService";
import RodzajKalendarzyService from "../rodzajeKalendarzy/RodzajKalendarzyService";
import KonfiguracjaService from "../../../../administracja/konfiguracja/KonfiguracjaService";

export default class KalendarzDoDatyContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            datyZKalendarzami: [],
            rodzajeKalendarzy: [],
            data_start: '',
            data_koniec: '',
            generujDisabled:false
        };
        this.getDatyZKalendarzami = this.getDatyZKalendarzami.bind(this)
        this.getRodzajeKalendarzy = this.getRodzajeKalendarzy.bind(this)
        this.onWyborZakresDat = this.onWyborZakresDat.bind(this)
        this.onChangeKalendarz = this.onChangeKalendarz.bind(this)
        this.onClickGeneruj = this.onClickGeneruj.bind(this)
        this.pobierzDatyOkresowe = this.pobierzDatyOkresowe.bind(this)
    }

    componentDidMount() {
        this.getRodzajeKalendarzy()
        this.pobierzDatyOkresowe()
    }

    pobierzDatyOkresowe() {

        KonfiguracjaService.pobierzWartoscStartRozkladu().then(function (responseStart) {
            KonfiguracjaService.pobierzWartoscKoniecRozkladu().then(function (responseKoniec) {
                let start = responseStart.data;
                let koniec = responseKoniec.data;

                this.setState({
                    start: start,
                    koniec: koniec,
                })

                this.onWyborZakresDat(start, koniec)
            }.bind(this))
        }.bind(this))
    }

    getDatyZKalendarzami(start, koniec) {
        KalendarzDoDatyService.getDatyZKalendarzami(start, koniec).then(function (response) {
            this.setState({datyZKalendarzami: response.data})
            if(response.data.find(r=>r.data==start) && response.data.find(r=>r.data==koniec)){
                this.setState({generujDisabled:true})
            }

        }.bind(this))

    }

    getRodzajeKalendarzy() {
        RodzajKalendarzyService.getKalendarze().then(function (response) {
            this.setState({rodzajeKalendarzy: response.data.content})
        }.bind(this))
    }

    onWyborZakresDat(start, koniec) {
        this.getDatyZKalendarzami(start, koniec);
        this.setState({
            data_start: start,
            data_koniec: koniec
        })
    }

    onClickGeneruj() {

        KonfiguracjaService.pobierzWartoscStartRozkladu().then(function (responseStart) {
            KonfiguracjaService.pobierzWartoscKoniecRozkladu().then(function (responseKoniec) {
                let start = responseStart.data;
                let koniec = responseKoniec.data;

                this.setState({
                    start: start,
                    koniec: koniec,
                })

                if (window.confirm('Zostanie wygenerowany okres od ' + start + ' do ' + koniec)) {
                    KalendarzDoDatyService.startProceduraGeneruj(start, koniec).then(function (response) {
                        if (response.status < 300) {
                            this.refs.notificator.success('Pomyślnie wygenerowano listę dat z kalendarzami', "", 3000)
                            this.onWyborZakresDat(start, koniec);
                            this.pobierzDatyOkresowe();
                        }
                        else {
                            this.refs.notificator.error('Wystąpił błąd podczas generowania listy', "", 3000)
                        }
                    }.bind(this))
                }

            }.bind(this))
        }.bind(this))

    }

    onChangeKalendarz(obj, nowy_kalendarz) {
        let new_obj;

        if (Boolean(nowy_kalendarz)) {
            new_obj = {
                "data": obj.data,
                "idRk": nowy_kalendarz.idRk,
                "opis": obj.opis,
                "wolne": obj.wolne,
                id: obj.id,
            }
        }
        else {
            new_obj = {
                "data": obj.data,
                "idRk": null,
                "opis": obj.opis,
                "wolne": obj.wolne,
                id: obj.id,
            }
        }

        KalendarzDoDatyService.editKalendarzDoDaty(obj.id, new_obj).then(function (response) {
            if (response.status < 300) {
                this.refs.notificator.success('Pomyślnie edytowano rodzaj kalendarza w danej dacie', "", 3000)
                if (this.state.data_start.length > 0 && this.state.data_koniec.length > 0) {
                    this.getDatyZKalendarzami(this.state.data_start, this.state.data_koniec)
                }
            }
            else {
                this.refs.notificator.error('Wystąpił błąd podczas edycji rodzaju kalendarza', "", 3000)
            }
        }.bind(this))

    }

    render() {

        return (
            <div>
                <ReactNotify ref='notificator'/>
                <Row>
                    <Col xs={12}>
                        <KalendarzDoDatyForm handleZakresDat={this.onWyborZakresDat} handleGeneruj={this.onClickGeneruj} start={this.state.data_start}
                                             koniec={this.state.data_koniec}
                                             generujDisabled={this.state.generujDisabled}
                        />
                    </Col>
                    <Col xs={12}>
                        {
                            (this.state.data_koniec.length > 0 || this.state.data_start.length > 0) ?
                                <KalendarzDoDatyTable data={this.state.datyZKalendarzami} rodzajeKalendarzy={this.state.rodzajeKalendarzy}
                                                      handleChangeKalendarz={this.onChangeKalendarz}/>
                                :
                                <div style={{height: '500px'}}></div>
                        }


                    </Col>
                </Row>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/rozkladConfig/kalendarze/przypisanieKalendarzaDoDaty/KalendarzDoDatyContainer.js